module.exports = __webpack_public_path__ + "img/facility6.dfa180a7.png";